<template>
  <div class="col-md-6 offset-md-3">
    <div class="login-form mt-4 p-4">
      <div class="row g-3">
        <h4>Добро пожаловать в Хлебушек!</h4>
        <div class="col-12">
          <label>Почта</label>
          <input type="email" name="email" class="form-control" placeholder="Email" v-model="email">
        </div>
        <div class="col-12">
          <label>Пароль</label>
          <input type="password" name="password" class="form-control" placeholder="Password" v-model="password">
        </div>
        <div class="col-12 error-placeholder">
          <error-label/>
        </div>
        <div class="col-12">
          <button type="submit" class="btn btn-dark float-end" @click="handleClickActionLogin" :disabled="disabledSubmit">Вход</button>
        </div>
      </div>
      <hr class="mt-4">
      <div class="col-12 mode-switcher-placeholder">
        <p class="text-center mb-0">Ещё не зарегистрированы? <a href="#" @click="handleClickModeRegister" data-mode="register">Регистрация</a></p>
        <p class="text-center mb-0">Есть аккаунт? <a href="#" @click="handleClickModeRestore" data-mode="restore">Восстановить</a></p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import ErrorLabel from "@/components/ui/ErrorLabel.vue";
import { latestMessage, type WebSocketMessageEmpty, type WebSocketMessageError } from "@/plugins/ws";
import { useToast } from "@/composables/useToast";
import {RootState} from "@/store";

defineOptions({
  name: 'ComponentsAuthLogin',
});

const emit = defineEmits<{
  switchMode: [mode: string];
}>();

const store = useStore<RootState>();

// Типы для WebSocket сообщений компонента Login
type LoginSuccessMessage = WebSocketMessageEmpty<'auth-login'>;
type LoginFailMessage = WebSocketMessageError<'auth-login-fail'>;

// Объединенный тип для всех сообщений
type LoginWebSocketMessageType = LoginSuccessMessage | LoginFailMessage;

const internalInstance = getCurrentInstance();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const wsSend = internalInstance?.appContext.config.globalProperties.$wsSend as (signal: string, payload: any) => void;

const email = ref('');
const password = ref('');
const latestMessageValue = ref(latestMessage);
const disabledSubmit = ref(false);

const setErrorReason = (reason: string) => store.dispatch('errorLabel/setErrorReason', reason);
const unsetErrorReason = () => store.dispatch('errorLabel/unsetErrorReason');

const { showToast } = useToast();

watch(email, () => {
  unsetErrorReason();
});

watch(password, () => {
  unsetErrorReason();
});

// WebSocket message handler
const handleWebSocketMessage = (data: LoginWebSocketMessageType): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'auth-login':
      signalLogin();
      break;
    case 'auth-login-fail':
      signalLoginFail(data.reason);
      break;
  }
};

watch(latestMessageValue, handleWebSocketMessage);

const handleClickActionLogin = () => {
  disabledSubmit.value = true;
  wsSend('authLogin', {
    email: email.value,
    password: password.value,
  });
};

const handleClickModeRestore = () => {
  emit('switchMode', 'restore');
};

const handleClickModeRegister = () => {
  emit('switchMode', 'register');
};

const signalLogin = () => {
  unsetErrorReason();
  disabledSubmit.value = false;
  showToast('Вход выполнен', 'Добро пожаловать!', 5000);

  // sleep for 1 second to allow the toast to be displayed

};

const signalLoginFail = (payload: string) => {
  setErrorReason(payload);
  disabledSubmit.value = false;
  showToast('Ошибка входа', payload, 15000);
};
</script>

<style scoped>

</style>